// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_WZpwQ {
    margin: 0px 16px 0px 16px;
}

.pane_U83T7 {
    border-top: 1px solid var(--color-base100)
}

.label_VYrTo {
    display: flex;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/dashboard/viewer/company/AutomaticLocationTransferCard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".text {\n    margin: 0px 16px 0px 16px;\n}\n\n.pane {\n    border-top: 1px solid var(--color-base100)\n}\n\n.label {\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `text_WZpwQ`,
	"pane": `pane_U83T7`,
	"label": `label_VYrTo`
};
export default ___CSS_LOADER_EXPORT___;
